import React from 'react'
import Special from './Special'

export default function index() {
  return (
    <Special/>
  )
}
